module.exports = __webpack_public_path__ + "img/2025-12_student-success.fc480c68.jpg";